/* ConcussionCare+ V2.0 — motion + count-up + video-performance layer (robust) */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function easeOut(t) { return 1 - Math.pow(1 - t, 3); }
  function countUp(el) {
    if (el.dataset.ccDone) return; el.dataset.ccDone = '1';
    var target = parseFloat(el.dataset.ccCount);
    if (isNaN(target)) return;
    var dec = parseInt(el.dataset.ccDec || '0', 10);
    var pre = el.dataset.ccPrefix || '', suf = el.dataset.ccSuffix || '';
    if (reduce) { el.textContent = pre + target.toFixed(dec) + suf; return; }
    var dur = 1200, start = null;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      el.textContent = pre + (target * easeOut(p)).toFixed(dec) + suf;
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  function runCounts(scope) {
    [].slice.call((scope || document).querySelectorAll('[data-cc-count]')).forEach(countUp);
  }

  function init() {
    var els = [];
    if (!reduce) {
      var sels = [
        '.cc-stat', '#cc-home .stat', '.ccp-card', '.ccp-recap span', '.ccf-shot', '.ccf-in > div:last-child',
        '.cca-card', '.cct b', '.ccw-card', '.ccc-scroll', '.ccr-card', '.ccs-card',
        '.ccfo-portrait', '.ccfo-in > div:last-child', '.ccq details', '.ccl-card',
        '.csp-row', '.csc-step', '.csc-vid', '.cse details', '.csf-in > *',
        '.cat-card', '.caf-row', '.cac-band', '.cac-priv'
        /* NOTE: .casc-c (homepage cascade cards) is deliberately NOT in this list.
           Those three cards are animated by their own inline-style engine below —
           class-based reveal proved unreliable for them (rule never applied in the
           browser despite being served). Do not re-add. */
      ];
      sels.forEach(function (s) {
        [].slice.call(document.querySelectorAll(s)).forEach(function (e) { els.push(e); });
      });
      els.forEach(function (e, i) { e.classList.add('cc-reveal'); e.style.transitionDelay = ((i % 5) * 50) + 'ms'; });

      /* Sequential 1 → 2 → 3 stagger for the cascade steps. Delay is keyed to the
         card's position within its row, not its global index, so the numbers always
         land in order regardless of what else is on the page. */
      /* Homepage cascade 1-2-3: fully inline-style driven.
         WHY: the class-based version (.cc-reveal/.cc-in in custom-brand.css) served
         correctly but the .cc-in rule never applied in the browser — cards sat at
         opacity 0 until the 4s failsafe. Root cause unresolvable from page JS (the
         CDN stylesheet is opaque cross-origin). Inline styles outrank every
         stylesheet, cascade layer, and minifier quirk, so the animation cannot be
         swallowed again. Self-contained: own observer, own failsafe. */
      (function () {
        var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        [].slice.call(document.querySelectorAll('.casc-row')).forEach(function (row) {
          var cards = [].slice.call(row.querySelectorAll('.casc-c'));
          if (!cards.length) return;
          if (reduce) return; /* leave fully visible, no motion */

          cards.forEach(function (card, idx) {
            var d = idx * 220;                     /* 0 / 220 / 440ms — clearly sequential */
            card.classList.remove('cc-reveal');    /* detach from the generic system */
            card.style.opacity = '0';
            card.style.transform = 'translateY(46px) scale(.965)';
            card.style.filter = 'blur(3px)';
            card.style.transition = 'opacity .85s cubic-bezier(.16,.84,.24,1) ' + d + 'ms,' +
                                    'transform .85s cubic-bezier(.16,.84,.24,1) ' + d + 'ms,' +
                                    'filter .85s cubic-bezier(.16,.84,.24,1) ' + d + 'ms';
            var badge = card.querySelector('i');   /* the number pops a beat after its card */
            if (badge) {
              badge.style.opacity = '0';
              badge.style.transform = 'scale(.5)';
              badge.style.transition = 'opacity .5s cubic-bezier(.34,1.56,.64,1) ' + (d + 180) + 'ms,' +
                                       'transform .5s cubic-bezier(.34,1.56,.64,1) ' + (d + 180) + 'ms';
            }
          });

          var fired = false;
          var go = function () {
            if (fired) return;
            fired = true;
            requestAnimationFrame(function () {
              cards.forEach(function (card) {
                card.style.opacity = '1';
                card.style.transform = 'none';
                card.style.filter = 'none';
                var badge = card.querySelector('i');
                if (badge) { badge.style.opacity = '1'; badge.style.transform = 'none'; }
              });
              /* After the entrance settles, clear the inline styles so the
                 CSS :hover lift (inline 'none' otherwise outranks it) and
                 tap feedback work again. */
              setTimeout(function () {
                cards.forEach(function (card) {
                  card.style.opacity = ''; card.style.transform = ''; card.style.filter = ''; card.style.transition = '';
                  var badge = card.querySelector('i');
                  if (badge) { badge.style.opacity = ''; badge.style.transform = ''; badge.style.transition = ''; }
                });
              }, 1600);
            });
          };

          /* Reveal the whole row off the FIRST card entering view, so the 1-2-3
             sequence is seen as a sequence even when cards are stacked on mobile. */
          if ('IntersectionObserver' in window) {
            var rowIO = new IntersectionObserver(function (ents) {
              ents.forEach(function (en) {
                if (!en.isIntersecting) return;
                go();
                rowIO.disconnect();
              });
            }, { threshold: 0, rootMargin: '0px 0px -12% 0px' });
            rowIO.observe(cards[0]);
          } else {
            go();
          }
          setTimeout(go, 5000);                    /* own failsafe — never leave them hidden */
        });
      })();

      var reveal = function (e) { e.classList.add('cc-in'); runCounts(e); };
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (ents) {
          ents.forEach(function (en) { if (en.isIntersecting) { reveal(en.target); io.unobserve(en.target); } });
        }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
        els.forEach(function (e) { io.observe(e); });
      }
      var check = function () {
        var vh = window.innerHeight || document.documentElement.clientHeight;
        for (var i = els.length - 1; i >= 0; i--) {
          var e = els[i];
          if (e.classList.contains('cc-in')) { els.splice(i, 1); continue; }
          var r = e.getBoundingClientRect();
          if (r.top < vh * 0.92 && r.bottom > 0) { reveal(e); els.splice(i, 1); }
        }
      };
      window.addEventListener('scroll', check, { passive: true });
      window.addEventListener('resize', check, { passive: true });
      document.addEventListener('scroll', check, { passive: true, capture: true });
      check();
      setTimeout(function () {
        [].slice.call(document.querySelectorAll('.cc-reveal:not(.cc-in)')).forEach(reveal);
        runCounts(document);
      }, 4000);
    } else {
      runCounts(document);
    }

    // ---- Video performance: pause loops when off-screen ----
    if ('IntersectionObserver' in window) {
      var vids = [].slice.call(document.querySelectorAll('video[autoplay], .ccp-card video, .csp-v video, .csc-vid video, .cch video'));
      var vio = new IntersectionObserver(function (ents) {
        ents.forEach(function (en) {
          var v = en.target;
          if (en.isIntersecting) { if (v.paused && v.muted) { v.play().catch(function () {}); } }
          else { if (!v.paused) { v.pause(); } }
        });
      }, { threshold: 0.05 });
      vids.forEach(function (v) { vio.observe(v); });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* ---- Buy box: preselect Subscribe & Save on load (2026-07-08).
   The native Shopify Subscriptions widget has no preselect setting;
   this clicks the subscription radio once after the widget renders.
   Guarded so it never fights a user's manual choice. ---- */
(function () {
  var done = false;
  function preselect() {
    var radios = [].slice.call(document.querySelectorAll('input[type="radio"][name^="purchaseOption"]'));
    if (!radios.length) return false;
    var groups = {};
    radios.forEach(function (r) { (groups[r.name] = groups[r.name] || []).push(r); });
    Object.keys(groups).forEach(function (name) {
      var g = groups[name];
      var sub = null, oneTime = null, oneTimeChecked = false;
      g.forEach(function (r) {
        if (/one_time_purchase$/.test(r.id)) { oneTime = r; if (r.checked) oneTimeChecked = true; }
        else if (!sub) { sub = r; }
      });
      if (/[?&]purchase=onetime/.test(location.search)) {
        if (oneTime && !oneTime.checked) { oneTime.click(); }
      } else if (sub && !sub.checked && oneTimeChecked) { sub.click(); }
    });
    done = true;
    return true;
  }
  function init() {
    if (preselect()) return;
    var tries = 0;
    var t = setInterval(function () {
      if (done || preselect() || ++tries > 40) clearInterval(t);
    }, 250);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* ===== Phase 2 (2026-07-08): email capture, popup, article CTAs, protocol kits ===== */
(function () {
  var SUB = 'cc_subscribed', LAST = 'cc_pop_last', DISS = 'cc_pop_diss';
  function store(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  function read(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function subscribed() { return read(SUB) === '1'; }
  function validEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); }

  /* All captures route through the server-rendered footer form so Shopify's
     spam-protection (captcha) script can intercept the real submit event.
     Success returns the visitor to the same page with ?cc-sub=1. */
  function showToast(msg) {
    var t = document.createElement('div');
    t.className = 'ccx-toast';
    t.textContent = msg || 'You\u2019re in \u2014 the guide is on its way. Check your inbox.';
    document.body.appendChild(t);
    setTimeout(function () { t.style.opacity = '0'; }, 5200);
    setTimeout(function () { t.remove(); }, 6000);
  }
  /* Direct-to-Klaviyo subscribe (2026-07-11): no Shopify form, no captcha,
     no page reload. Adds to Email List SmYg5T -> welcome flow fires. */
  function submitEmail(email, tags) {
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=TrzkxD', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
      body: JSON.stringify({ data: { type: 'subscription', attributes: {
        custom_source: tags || 'newsletter',
        profile: { data: { type: 'profile', attributes: { email: email } } }
      }, relationships: { list: { data: { type: 'list', id: 'SmYg5T' } } } } })
    }).then(function (r) {
      if (r.ok || r.status === 202) {
        store(SUB, '1');
        try { document.dispatchEvent(new CustomEvent('cc:lead', { detail: { tags: tags } })); } catch (e) {}
        return true;
      }
      return false;
    }).catch(function () { return false; });
  }

  function wireField(wrap, tags) {
    if (!wrap || wrap.dataset.ccWired) return;
    var input = wrap.querySelector('input[type="email"], input[placeholder*="email" i]');
    var btn = wrap.querySelector('.ccx-field button') || (function () {
      var bs = [].slice.call(wrap.querySelectorAll('button'));
      for (var i = 0; i < bs.length; i++) { if (!bs[i].classList.contains('ccx-x')) return bs[i]; }
      return bs[0] || null;
    })();
    if (!input || !btn) return;
    wrap.dataset.ccWired = '1';
    function go(ev) {
      if (ev) ev.preventDefault();
      var v = (input.value || '').trim();
      if (!validEmail(v)) { input.style.outline = '2px solid #e66a6a'; input.focus(); return; }
      input.style.outline = '';
      btn.disabled = true; btn.textContent = 'Sending\u2026';
      submitEmail(v, tags).then(function (ok) {
        if (ok) {
          btn.textContent = 'Sent \u2713';
          showToast();
          var pop = wrap.closest ? wrap.closest('.ccx-pop') : null;
          if (pop) setTimeout(function () {
            var ov = document.querySelector('.ccx-ov'); if (ov) ov.remove(); pop.remove();
          }, 900);
        } else { btn.disabled = false; btn.textContent = 'Try again'; }
      });
    }
    /* Mobile-proof submit: click alone fails on iOS (keyboard-dismiss shifts
       layout mid-tap), so bind pointerup + touchend + click with a busy-guard
       against double-fires. */
    var busy = false;
    function goOnce(e) {
      if (busy) return; busy = true;
      setTimeout(function () { busy = false; }, 1600);
      if (e && e.cancelable) e.preventDefault();
      go(e);
    }
    /* touchstart fires the moment the finger lands — before iOS dismisses the
       keyboard and re-centers the popup (which cancels later tap events). */
    btn.addEventListener('touchstart', goOnce, { passive: false });
    btn.addEventListener('pointerup', goOnce);
    btn.addEventListener('touchend', goOnce, { passive: false });
    btn.addEventListener('click', goOnce);
    input.addEventListener('keydown', function (e) { if (e.key === 'Enter') goOnce(e); });
  }

  /* Success toast when returning from a capture */
  function successReturn() {
    if (!/[?&]cc-sub=1/.test(location.search)) return;
    store(SUB, '1');
    try { localStorage.removeItem('cc_sub_pending'); } catch (e) {}
    try { history.replaceState(null, '', location.pathname + location.hash); } catch (e) {}
    var t = document.createElement('div');
    t.className = 'ccx-toast';
    t.textContent = 'You\u2019re in \u2014 the guide is on its way. Check your inbox.';
    document.body.appendChild(t);
    setTimeout(function () { t.style.opacity = '0'; }, 5200);
    setTimeout(function () { t.remove(); }, 6000);
  }

  /* Wire the homepage lead-magnet box (was a dummy input with no form) */
  function wireExisting() {
    [].slice.call(document.querySelectorAll('.leadmag .field')).forEach(function (w) {
      wireField(w, 'newsletter, recovery-guide');
    });
    /* Footer form is intentionally NOT wired: it submits natively through
       Shopify's own handler and shows form.posted_successfully? inline. */
  }

  /* Popup (skip on product, cart, checkout pages) */
  function popup() {
    var force = /[?&]cc-pop=1/.test(location.search); /* test hook */
    if (subscribed() && !force) return;
    var p = location.pathname;
    if (!force && (p.indexOf('/products/') === 0 || p.indexOf('/cart') === 0 || p.indexOf('/checkout') === 0)) return;
    var diss = parseInt(read(DISS) || '0', 10);
    var last = parseInt(read(LAST) || '0', 10);
    var wait = diss >= 2 ? 60 : 14; /* days */
    if (!force && Date.now() - last < wait * 864e5) return;
    var shown = false;
    function show() {
      if (shown || (subscribed() && !force)) return; shown = true;
      store(LAST, String(Date.now()));
      var ov = document.createElement('div'); ov.className = 'ccx-ov';
      var pop = document.createElement('div'); pop.className = 'ccx-pop';
      pop.innerHTML =
        '<button class="ccx-x" aria-label="Close">\u00d7</button>' +
        '<p class="ccx-kick">Free download</p>' +
        '<h3>The Concussion Recovery Essentials Guide</h3>' +
        '<p>Evidence-informed strategies for supporting brain recovery \u2014 nutrition, rest, and routine. Straight to your inbox.</p>' +
        '<div class="ccx-field"><input type="email" placeholder="Your email address" aria-label="Email address"><button>Send me the guide</button></div>' +
        '<p class="ccx-fine">Recovery science, no spam. Unsubscribe anytime.</p>';
      document.body.appendChild(ov); document.body.appendChild(pop);
      requestAnimationFrame(function () { ov.className += ' ccx-on'; pop.className += ' ccx-on'; });
      function close() {
        store(DISS, String(diss + 1));
        ov.remove(); pop.remove();
        document.removeEventListener('keydown', esc);
      }
      function esc(e) { if (e.key === 'Escape') close(); }
      ov.addEventListener('click', close);
      pop.querySelector('.ccx-x').addEventListener('click', close);
      document.addEventListener('keydown', esc);
      wireField(pop, 'newsletter, recovery-guide, popup');
    }
    if (force) { show(); return; }
    setTimeout(show, 22000);
    var scrollFn = function () {
      var d = document.documentElement;
      if ((window.scrollY + window.innerHeight) / d.scrollHeight > 0.55) { show(); window.removeEventListener('scroll', scrollFn); }
    };
    window.addEventListener('scroll', scrollFn, { passive: true });
    document.addEventListener('mouseout', function (e) {
      if (!e.relatedTarget && e.clientY <= 0 && window.innerWidth > 820) show();
    });
  }

  /* Article inline CTAs */
  function articleCtas() {
    if (location.pathname.indexOf('/blogs/') !== 0) return;
    var candidates = [].slice.call(document.querySelectorAll('.ar-body, article, .article-content, .article__content, .rte'));
    var body = null, best = 0;
    candidates.forEach(function (c) {
      var n = c.querySelectorAll(':scope > p').length;
      if (n > best) { best = n; body = c; }
    });
    if (!body || best < 4) return;
    function box() {
      var d = document.createElement('div');
      d.className = 'ccx-cta';
      d.innerHTML =
        '<p class="ccx-kick">Free download</p>' +
        '<h4>Get the Concussion Recovery Essentials Guide</h4>' +
        '<p>Evidence-informed strategies for brain recovery \u2014 nutrition, rest, and routine. Free to your inbox.</p>' +
        '<div class="ccx-field"><input type="email" placeholder="Your email address" aria-label="Email address"><button>Send me the guide</button></div>' +
        '<p class="ccx-fine">Recovery science, no spam. Unsubscribe anytime.</p>';
      return d;
    }
    var ps = [].slice.call(body.querySelectorAll(':scope > p'));
    if (ps.length > 6) { var mid = box(); ps[3].parentNode.insertBefore(mid, ps[3].nextSibling); wireField(mid, 'newsletter, recovery-guide, article'); }
    if (!document.querySelector('.ar-ctaband')) { var end = box(); body.appendChild(end); wireField(end, 'newsletter, recovery-guide, article'); }
  }

  /* Protocol kits on flagship PDP */
  function kits() {
    if (location.pathname.indexOf('/products/concussioncare-cognitive-recovery-support') !== 0) return;
    var anchor = document.querySelector('[class*="text_ccTrust"]');
    var col = document.querySelector('.buy-buttons-block');
    col = anchor || (col && col.closest('.group-block-content'));
    if (!col || document.querySelector('.ccx-kits')) return;
    Promise.all([
      fetch('/products/concussioncare-cognitive-recovery-support.js').then(function (r) { return r.json(); }),
      fetch('/products/2-month-bundle.js').then(function (r) { return r.json(); }),
      fetch('/products/3-month-bundle.js').then(function (r) { return r.json(); })
    ]).then(function (res) {
      var base = res[0].variants[0].price;
      function money(c) { return '$' + (c / 100).toFixed(2); }
      var wrap = document.createElement('div');
      wrap.className = 'ccx-kits';
      var rows = [
        { p: res[1], n: 2, label: '60-Day Protocol Kit', badge: '' },
        { p: res[2], n: 3, label: '90-Day Protocol Kit', badge: 'Best for full recovery arc' }
      ];
      var html = '<h4>Prefer a fixed supply?</h4><p class="ccx-sub">One-time protocol kits \u2014 no subscription, ships free.</p>';
      rows.forEach(function (r) {
        var v = r.p.variants[0];
        if (!v.available) return;
        var save = base * r.n - v.price;
        html += '<div class="ccx-kit"><div><b>' + r.label +
          (r.badge ? '<span class="ccx-badge">' + r.badge + '</span>' : '') + '</b>' +
          '<span class="ccx-save">' + money(v.price) + ' \u00b7 Save ' + money(save) + '</span></div>' +
          '<button data-vid="' + v.id + '" data-price="' + v.price + '" data-label="' + r.label + '">Add kit</button></div>';
      });
      wrap.innerHTML = html;
      if (anchor) { anchor.insertAdjacentElement('afterend', wrap); } else { col.appendChild(wrap); }
      [].slice.call(wrap.querySelectorAll('button[data-vid]')).forEach(function (b) {
        b.addEventListener('click', function () {
          b.disabled = true; b.textContent = 'Adding\u2026';
          if (window.ccGa4) ccGa4('add_to_cart', { currency: 'USD', value: parseInt(b.dataset.price || 0, 10) / 100, items: [{ item_id: b.getAttribute('data-vid'), item_name: b.dataset.label || 'Protocol Kit', quantity: 1 }] });
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: parseInt(b.getAttribute('data-vid'), 10), quantity: 1 }] })
          }).then(function (r) {
            if (r.ok) { location.href = '/cart'; }
            else { b.disabled = false; b.textContent = 'Add kit'; }
          }).catch(function () { b.disabled = false; b.textContent = 'Add kit'; });
        });
      });
    }).catch(function () {});
  }

  function init2() { successReturn(); wireExisting(); popup(); articleCtas(); kits(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init2);
  else init2();
})();


/* ===== Batch 2 (2026-07-10): cart drawer enhancements ===== */
(function () {
  var FLAG = 'concussioncare-cognitive-recovery-support';
  var KITS = ['2-month-bundle', '3-month-bundle'];
  var kitCache = null;

  function money(c) { return '$' + (c / 100).toFixed(2); }

  function collapseNote(root) {
    [].slice.call(root.querySelectorAll('.cart-note details[open]')).forEach(function (d) {
      if (!d.dataset.ccSeen) { d.dataset.ccSeen = '1'; d.removeAttribute('open'); }
    });
  }

  function kitData() {
    if (kitCache) return Promise.resolve(kitCache);
    return Promise.all(KITS.map(function (h) {
      return fetch('/products/' + h + '.js').then(function (r) { return r.json(); });
    })).then(function (res) { kitCache = res; return res; });
  }

  function injectUpsell(root) {
    if (root.querySelector('#ccx-dkit')) return;
    var summary = root.querySelector('.cart-drawer__summary');
    if (!summary) return;
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var flagLine = null, hasKit = false;
      (cart.items || []).forEach(function (it) {
        if (it.handle === FLAG) flagLine = it;
        if (KITS.indexOf(it.handle) > -1) hasKit = true;
      });
      if (!flagLine || hasKit) return;
      if (root.querySelector('#ccx-dkit')) return;
      Promise.all([kitData(), fetch('/products/' + FLAG + '.js').then(function (r) { return r.json(); })]).then(function (arr) {
        var kits = arr[0], flag = arr[1];
        if (root.querySelector('#ccx-dkit')) return;
        /* kits are one-time; compare against the flagship one-time unit price for an honest saving */
        var base = flag.price;
        var box = document.createElement('div');
        box.className = 'ccx-dkit'; box.id = 'ccx-dkit';
        var html = '<h5>Save more with a Protocol Kit</h5><p>One-time kits \u2014 no subscription, ships free.</p><div class="ccx-dkit-row">';
        kits.forEach(function (k, i) {
          var v = k.variants[0]; if (!v || !v.available) return;
          var n = i + 2;
          var save = base * n - v.price;
          html += '<button data-vid="' + v.id + '" data-price="' + v.price + '" data-label="' + (n * 30) + '-Day Protocol Kit">' + (n * 30) + '-Day Kit \u00b7 ' + money(v.price) +
                  (save > 0 ? ' <span style="font-weight:500">(save ' + money(save) + ')</span>' : '') + '</button>';
        });
        html += '</div>';
        box.innerHTML = html;
        summary.parentNode.insertBefore(box, summary);
        [].slice.call(box.querySelectorAll('button[data-vid]')).forEach(function (b) {
          b.addEventListener('click', function () {
            b.disabled = true; b.textContent = 'Switching\u2026';
            if (window.ccGa4) ccGa4('add_to_cart', { currency: 'USD', value: parseInt(b.dataset.price || 0, 10) / 100, items: [{ item_id: b.getAttribute('data-vid'), item_name: b.dataset.label || 'Protocol Kit', quantity: 1 }] });
            fetch('/cart/change.js', {
              method: 'POST', headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: flagLine.key, quantity: 0 })
            }).then(function () {
              return fetch('/cart/add.js', {
                method: 'POST', headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ items: [{ id: parseInt(b.getAttribute('data-vid'), 10), quantity: 1 }] })
              });
            }).then(function (r) {
              if (r.ok) { location.href = '/cart'; } else { b.disabled = false; b.textContent = 'Try again'; }
            }).catch(function () { b.disabled = false; b.textContent = 'Try again'; });
          });
        });
      });
    }).catch(function () {});
  }

  function init3() {
    var comp = document.querySelector('cart-drawer-component');
    if (!comp) return;
    var mo = new MutationObserver(function () { collapseNote(comp); injectUpsell(comp); });
    mo.observe(comp, { childList: true, subtree: true, attributes: true, attributeFilter: ['open'] });
    collapseNote(comp); injectUpsell(comp);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init3);
  else init3();
})();


/* ===== Batch 3 (2026-07-10): GA4 event hardening + reveal on resources ===== */
(function () {
  function ga4(name, params) {
    try { if (typeof window.gtag === 'function') window.gtag('event', name, params); } catch (e) {}
  }
  window.ccGa4 = ga4;
  /* lead events for all custom email captures (leadmag, popup, article) */
  document.addEventListener('cc:lead', function (e) {
    ga4('generate_lead', { method: (e.detail && e.detail.tags) || 'newsletter' });
  });
  /* reveal hooks for resources/providers cards (motion layer reads .cc-reveal) */
  var extra = ['#ccwrap-resources .rs-card', '#ccwrap-prov .pv-cred', '#ccwrap-resources .rs-band'];
  extra.forEach(function (sel) {
    [].slice.call(document.querySelectorAll(sel)).forEach(function (el, i) {
      if (el.classList.contains('cc-reveal')) return;
      el.classList.add('cc-reveal');
      el.style.transitionDelay = ((i % 4) * 60) + 'ms';
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (ents) {
          ents.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('cc-in'); io.unobserve(en.target); } });
        }, { threshold: 0.1 });
        io.observe(el);
      } else { el.classList.add('cc-in'); }
    });
  });
})();


/* ===== Batch 4 (2026-07-11): ingredient hotspots + announcement rotation ===== */
(function () {
  /* --- PDP ingredient hotspots --- */
  function hotspots() {
    if (location.pathname.indexOf('/products/concussioncare-cognitive-recovery-support') !== 0) return;
    var stage = document.querySelector('.product-information__media .product-media-container');
    if (!stage || stage.querySelector('.ccx-hs-wrap')) return;
    var DATA = [
      { x: 30, y: 26, n: 'Creatine Monohydrate', d: '5 g', p: 'Supports cellular ATP production to meet the brain\u2019s energy demand.' },
      { x: 68, y: 38, n: 'Turmeric Root Extract', d: '1 g \u00b7 95% curcumin', p: 'Supports a healthy, balanced neuroinflammatory response.' },
      { x: 34, y: 55, n: 'N-Acetyl Cysteine (NAC)', d: '600 mg', p: 'Antioxidant support against oxidative and metabolic stress.' },
      { x: 66, y: 68, n: 'Resveratrol', d: '250 mg \u00b7 98%', p: 'Polyphenol support for oxidative balance and healthy signaling.' },
      { x: 38, y: 82, n: 'Magnesium Taurinate', d: '153 mg', p: 'Supports neurotransmitter balance and steady neural signaling.' }
    ];
    var wrap = document.createElement('div');
    wrap.className = 'ccx-hs-wrap';
    stage.style.position = 'relative';
    var openCard = null;
    function close() { if (openCard) { openCard.remove(); openCard = null; } }
    DATA.forEach(function (h) {
      var dot = document.createElement('button');
      dot.className = 'ccx-hs'; dot.type = 'button';
      dot.setAttribute('aria-label', h.n + ' ' + h.d);
      dot.style.left = h.x + '%'; dot.style.top = h.y + '%';
      function toggle(e) {
        if (e && e.cancelable) e.preventDefault();
        if (openCard && openCard.dataset.n === h.n) { close(); return; }
        close();
        var c = document.createElement('div');
        c.className = 'ccx-hs-card'; c.dataset.n = h.n;
        c.innerHTML = '<b>' + h.n + '</b><span class="d">' + h.d + '</span><p>' + h.p + '</p>';
        c.style.left = Math.min(h.x, 55) + '%';
        c.style.top = Math.min(h.y + 5, 78) + '%';
        wrap.appendChild(c);
        openCard = c;
      }
      dot.addEventListener('touchstart', toggle, { passive: false });
      dot.addEventListener('click', toggle);
      wrap.appendChild(dot);
    });
    document.addEventListener('click', function (e) { if (openCard && !wrap.contains(e.target)) close(); });
    stage.appendChild(wrap);
  }

  /* --- Announcement bar rotation (mobile only; desktop keeps all three) --- */
  function announceRotate() {
    var bar = document.querySelector('.cc-announce');
    if (!bar) return;
    var spans = [].slice.call(bar.querySelectorAll('span'));
    if (spans.length < 2) return;
    var mq = window.matchMedia('(max-width: 700px)');
    var timer = null, idx = 0;
    function start() {
      if (timer) return;
      bar.classList.add('ccx-rotating');
      spans.forEach(function (s, i) { s.classList.toggle('ccx-on', i === 0); });
      idx = 0;
      timer = setInterval(function () {
        spans[idx].classList.remove('ccx-on');
        idx = (idx + 1) % spans.length;
        spans[idx].classList.add('ccx-on');
      }, 4000);
    }
    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
      bar.classList.remove('ccx-rotating');
      spans.forEach(function (s) { s.classList.remove('ccx-on'); });
    }
    function apply() { if (mq.matches) start(); else stop(); }
    mq.addEventListener ? mq.addEventListener('change', apply) : mq.addListener(apply);
    apply();
  }

  function init4() { hotspots(); announceRotate(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init4);
  else init4();
})();

/* ---- Perf (2026-07-12): lazy videos.
   Below-fold <video class="cc-lv"> ship with preload="none" and NO autoplay, so the
   browser fetches nothing until the user scrolls near them. Posters show immediately.
   On approach we start playback; the existing off-screen pause layer takes over after. ---- */
(function () {
  function initLazyVid() {
    var vids = [].slice.call(document.querySelectorAll('video.cc-lv'));
    if (!vids.length) return;

    function hydrate(v) {
      if (v.dataset.ccLv) return;
      v.dataset.ccLv = '1';
      try { v.preload = 'auto'; } catch (e) {}
      if (v.muted !== true) v.muted = true;   // required for programmatic play
      v.setAttribute('playsinline', '');
      var p = v.play();
      if (p && p.catch) p.catch(function () { /* poster stays; no error surfaced */ });
    }

    if (!('IntersectionObserver' in window)) {
      vids.forEach(hydrate);
      return;
    }
    // rootMargin: begin loading ~1 viewport early so playback looks instant
    var io = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) {
        if (en.isIntersecting) { hydrate(en.target); io.unobserve(en.target); }
      });
    }, { rootMargin: '600px 0px', threshold: 0.01 });
    vids.forEach(function (v) { io.observe(v); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initLazyVid);
  else initLazyVid();
})();

/* ============================================================
   cc-drawer-edit v2 — DYNAMIC cart editing inside the slide-out drawer
   (2026-07-18, replaces v1 same day).
   Jon's repro: add item -> hit BACK -> add another -> can't edit (mobile).
   v1 bug: panel built once, guarded by existence, went stale when the
   cart changed underneath it (bfcache restores, partial drawer
   re-renders). v2 is fingerprint-driven: any time the cart's real state
   (line keys+qtys+total) differs from what the panel shows, the panel
   is rebuilt from /cart.js. Triggers: drawer mutations, pageshow
   (bfcache), visibilitychange, 3.5s poll, and after every edit.
   Edits update IN PLACE via the Section Rendering API (drawer section
   re-render); full reload is the fallback, never the default.
   NOTE: Claude's automation cannot test cart mutations (bot defense
   redirects synthetic add-to-cart to an empty checkout) — verify on a
   real phone after pushing.
   ============================================================ */
(function () {
  var BUSY = false;
  var lastFp = '';

  function fp(cart) {
    return cart.items.map(function (i) { return i.key + 'x' + i.quantity; }).join('|') + '#' + cart.total_price;
  }

  function money(cents) { return '$' + (cents / 100).toFixed(2); }

  function drawerEl() {
    return document.querySelector('cart-drawer-component,cart-drawer,#CartDrawer,[id*="CartDrawer"]');
  }

  /* Re-render the theme's own drawer markup so counts/totals stay true. */
  function refreshDrawer() {
    var dr = drawerEl();
    if (!dr) return Promise.reject(new Error('no drawer'));
    var wrap = dr.closest('[id^="shopify-section-"]');
    var getFresh;
    if (wrap) {
      var sid = wrap.id.replace('shopify-section-', '');
      getFresh = fetch('/?sections=' + encodeURIComponent(sid))
        .then(function (r) { if (!r.ok) throw new Error('section render failed'); return r.json(); })
        .then(function (j) {
          if (!j[sid]) throw new Error('no section html');
          var tmp = document.createElement('div');
          tmp.innerHTML = j[sid];
          return tmp.querySelector('cart-drawer-component,cart-drawer,#CartDrawer,[id*="CartDrawer"]');
        });
    } else {
      /* This theme's drawer is not a section — re-fetch the whole current
         page and lift the freshly rendered drawer out of it. */
      getFresh = fetch(window.location.pathname, { headers: { 'Accept': 'text/html' } })
        .then(function (r) { if (!r.ok) throw new Error('page fetch failed'); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          return doc.querySelector('cart-drawer-component,cart-drawer,#CartDrawer,[id*="CartDrawer"]');
        });
    }
    return getFresh.then(function (fresh) {
      if (!fresh) throw new Error('no fresh drawer');
      var wasOpen = dr.hasAttribute('open') || dr.classList.contains('active') || dr.classList.contains('is-open');
      dr.innerHTML = fresh.innerHTML;
      if (wasOpen) dr.setAttribute('open', '');
      return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        [].slice.call(document.querySelectorAll('[class*="cart-count"],[id*="cart-count"],[data-cart-count]')).forEach(function (el) {
          el.textContent = cart.item_count;
        });
      });
    });
  }

  function change(key, qty, btn) {
    if (BUSY) return;
    BUSY = true;
    if (btn) { btn.disabled = true; btn.style.opacity = '.4'; }
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { if (!r.ok) throw new Error('change failed'); return r.json(); })
      .then(function () {
        return refreshDrawer().catch(function () { location.reload(); });
      })
      .then(function () { BUSY = false; sync(true); })
      .catch(function () {
        BUSY = false;
        if (btn) { btn.disabled = false; btn.style.opacity = ''; }
        alert('Could not update the cart. Please try again, or use the full cart page.');
      });
  }

  function render(dr, cart) {
    var old = dr.querySelector('.cc-dw-edit');
    if (old) old.remove();
    if (!cart.items.length) { lastFp = fp(cart); return; }
    var box = document.createElement('div');
    box.className = 'cc-dw-edit';
    box.setAttribute('data-fp', fp(cart));
    box.style.cssText = 'padding:14px 16px;border-top:1px solid #e3edf1;background:#f6fafb;';
    var h = document.createElement('div');
    h.textContent = 'Edit items';
    h.style.cssText = 'font-weight:700;font-size:13px;margin-bottom:8px;color:#0b3c4d;';
    box.appendChild(h);
    cart.items.forEach(function (it) {
      var row = document.createElement('div');
      row.style.cssText = 'display:flex;flex-wrap:wrap;align-items:center;gap:8px;margin:9px 0;font-size:13px;color:#123a46;';
      var nm = document.createElement('span');
      nm.textContent = it.product_title + (it.selling_plan_allocation ? ' (subscription)' : '') + ' \u00b7 ' + money(it.final_line_price);
      nm.style.cssText = 'flex:1 1 100%;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-weight:600;';
      function btn(t, fn) {
        var b = document.createElement('button');
        b.type = 'button'; b.textContent = t;
        b.setAttribute('aria-label', (t === '\u2212' ? 'Decrease' : 'Increase') + ' quantity of ' + it.product_title);
        b.style.cssText = 'width:34px;height:34px;border:1px solid #cfdfe5;background:#fff;border-radius:8px;font-size:16px;cursor:pointer;line-height:1;';
        b.addEventListener('click', function () { fn(b); });
        return b;
      }
      var q = document.createElement('span');
      q.textContent = it.quantity;
      q.style.cssText = 'min-width:20px;text-align:center;font-weight:700;';
      var rm = document.createElement('button');
      rm.type = 'button'; rm.textContent = 'Remove';
      rm.setAttribute('aria-label', 'Remove ' + it.product_title + ' from cart');
      rm.style.cssText = 'border:none;background:none;color:#8a2b2b;font-size:12px;cursor:pointer;text-decoration:underline;padding:6px 2px;';
      rm.addEventListener('click', function () { change(it.key, 0, rm); });
      row.appendChild(nm);
      row.appendChild(btn('\u2212', function (b) { change(it.key, it.quantity - 1, b); }));
      row.appendChild(q);
      row.appendChild(btn('+', function (b) { change(it.key, it.quantity + 1, b); }));
      row.appendChild(rm);
      box.appendChild(row);
    });
    var tot = document.createElement('div');
    tot.textContent = 'Subtotal: ' + money(cart.total_price);
    tot.style.cssText = 'margin-top:8px;font-weight:700;font-size:13px;color:#0b3c4d;';
    box.appendChild(tot);
    var link = document.createElement('a');
    link.href = '/cart';
    link.textContent = 'Open full cart page \u2192';
    link.style.cssText = 'display:inline-block;margin-top:6px;font-size:12.5px;color:#0F7D76;';
    box.appendChild(link);
    var items = dr.querySelector('cart-items-component,[class*="cart-items"],[id*="CartDrawer-CartItems"]');
    if (items && items.parentNode) {
      items.parentNode.insertBefore(box, items.nextSibling);
    } else {
      /* No items markup (e.g. stale "empty" body). Mount inside the visible
         sheet — the child that is actually the slide-over panel — so the
         controls are never clipped under the sheet's left edge. */
      var sheet = null;
      var kids = [].slice.call(dr.children);
      for (var k = 0; k < kids.length; k++) {
        var r = kids[k].getBoundingClientRect();
        if (r.width > 240 && r.width < window.innerWidth * 0.99 && r.height > 200) { sheet = kids[k]; break; }
      }
      if (!sheet) {
        for (var k2 = 0; k2 < kids.length; k2++) {
          if (kids[k2].querySelector && kids[k2].querySelector('a,button')) { sheet = kids[k2]; break; }
        }
      }
      (sheet || dr).appendChild(box);
    }
    box.style.boxSizing = 'border-box';
    box.style.maxWidth = '100%';
    lastFp = fp(cart);
  }

  var SYNCING = false;
  function sync(force) {
    if (SYNCING) return;
    var dr = drawerEl();
    if (!dr) return;
    SYNCING = true;
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var f = fp(cart);
        var panel = dr.querySelector('.cc-dw-edit');
        if (force || f !== lastFp || (!panel && cart.items.length) || (panel && panel.getAttribute('data-fp') !== f)) {
          render(dr, cart);
        }
        /* Theme drawer showing "empty" (or wrong item rows) while the real
           cart has items = stale bfcache render. Re-render the section so
           the drawer body itself tells the truth, not just our panel. */
        if (cart.item_count > 0) {
          var themeRows = [].slice.call(dr.querySelectorAll('[class*="cart-item"]')).filter(function (n) { return !n.closest('.cc-dw-edit'); }).length;
          var looksEmpty = /cart is empty/i.test(dr.textContent) || themeRows === 0;
          if (looksEmpty && !dr.getAttribute('data-cc-refreshing')) {
            dr.setAttribute('data-cc-refreshing', '1');
            refreshDrawer()
              .catch(function () {})
              .then(function () { dr.removeAttribute('data-cc-refreshing'); render(dr, cart); });
          }
        }
      })
      .catch(function () {})
      .then(function () { SYNCING = false; });
  }

  function init() {
    var dr = drawerEl();
    if (!dr) return;
    sync(true);
    var t = null;
    new MutationObserver(function (muts) {
      /* ignore mutations caused by our own panel */
      var external = muts.some(function (m) {
        var n = m.target;
        return !(n.closest && n.closest('.cc-dw-edit'));
      });
      if (!external) return;
      clearTimeout(t);
      t = setTimeout(function () { sync(false); }, 250);
    }).observe(dr, { childList: true, subtree: true, attributes: true, attributeFilter: ['open', 'class'] });
    /* bfcache restore = the back-button case */
    window.addEventListener('pageshow', function (e) { if (e.persisted) { refreshDrawer().catch(function () {}).then(function () { sync(true); }); } else sync(false); });
    document.addEventListener('visibilitychange', function () { if (!document.hidden) sync(false); });
    setInterval(function () { sync(false); }, 3500);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* ============================================================
   cc-hero-vid v4 — seamless poster-to-video handoff (2026-08-02).

   WHY v3's crossfade flashed: the single poster was cut from the DESKTOP
   master, but phones play the BT.709-retagged mobile rendition, whose
   opening frame is measurably different (RMS 6.7, red/green off by ~7).
   Poster and first frame simply weren't the same picture, so the swap
   was visible. v4 ships a poster cut from EACH video's true frame 0
   (both now match at RMS ~1.0 = JPEG noise only).

   No-flash guarantees, in order of importance:
   1. The poster <img> is never removed and never fades. It sits under
      the video permanently, so there is no moment with nothing painted.
   2. The video starts at opacity 0 and is revealed ONLY after the
      decoder has actually presented a frame (requestVideoFrameCallback).
      No black box, no half-decoded frame.
   3. Poster and video are chosen by the SAME decision: we read
      img.currentSrc to see which <source> the browser itself picked.
      They cannot disagree, on any device or viewport.
   4. Since frame 0 == poster, the 600ms linear fade blends two identical
      images — the composite never changes brightness. Invisible by math,
      not by luck.
   5. Any failure (autoplay blocked, decode error, reduced motion) simply
      leaves the poster showing. Nothing flashes, nothing goes blank.
   ============================================================ */
(function () {
  function init() {
    var v = document.getElementById('cc-hero-vid');
    var img = document.getElementById('cc-hero-poster');
    if (!v || !v.getAttribute('data-vsrc')) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return; /* poster only */

    /* Match the video to whichever poster the browser actually chose.
       currentSrc is resolved by the rendering engine itself, so it stays
       correct under device emulation where matchMedia can misreport. */
    var picked = (img && (img.currentSrc || img.src)) || '';
    var useMobile = picked.indexOf('poster-mobile') >= 0;
    var src = useMobile
      ? (v.getAttribute('data-vsrc-mobile') || v.getAttribute('data-vsrc'))
      : v.getAttribute('data-vsrc');

    var revealed = false;
    function reveal() {
      if (revealed) return;
      revealed = true;
      v.classList.add('cc-live');   /* poster stays underneath, forever */
    }

    /* Reveal only once a real frame exists on screen. */
    if (typeof v.requestVideoFrameCallback === 'function') {
      v.requestVideoFrameCallback(reveal);
    } else {
      /* Older Safari/Firefox: timeupdate fires after playback truly advances,
         which means a frame has been presented. Safer than 'canplay'. */
      v.addEventListener('timeupdate', function onTU() {
        if (v.currentTime > 0) { v.removeEventListener('timeupdate', onTU); reveal(); }
      });
    }

    var s = document.createElement('source');
    s.src = src;
    s.type = 'video/mp4';
    v.appendChild(s);
    v.muted = true;            /* required for autoplay */
    v.autoplay = true;
    v.load();
    var p = v.play();
    if (p && p.catch) p.catch(function () { /* blocked: poster simply remains */ });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* cc-video-tracks — attach an (empty) captions track to every video so the
   Lighthouse audio/video accessibility audit passes. All site videos are
   silent/decorative; the track declares "no spoken content" formally. */
(function () {
  function init() {
    var me = [].slice.call(document.scripts).filter(function (s) { return s.src.indexOf('custom-brand') >= 0; })[0];
    if (!me) return;
    var vtt = me.src.split('?')[0].replace(/custom-brand\.js$/, 'cc-captions-empty.vtt');
    [].slice.call(document.querySelectorAll('video')).forEach(function (v) {
      if (v.querySelector('track')) return;
      var t = document.createElement('track');
      t.kind = 'captions'; t.srclang = 'en'; t.label = 'English'; t.src = vtt;
      v.appendChild(t);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* cc-casc-tap — the homepage 1-2-3 cascade cards look interactive, so make
   them interactive (Jon, 2026-07-18): tap/click/Enter opens the full
   interactive cascade on The Science page. Cards stay claims-free here. */
(function () {
  function init() {
    [].slice.call(document.querySelectorAll('#cc-home .casc-c')).forEach(function (card) {
      card.style.cursor = 'pointer';
      card.setAttribute('role', 'link');
      card.setAttribute('tabindex', '0');
      card.setAttribute('aria-label', 'Explore the full interactive cascade on The Science page');
      function go() { window.location.href = '/pages/the-science#cascade'; }
      card.addEventListener('click', go);
      card.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); go(); } });
      /* tap feedback on touch (hover-lift already exists for pointers) */
      card.addEventListener('touchstart', function () { card.style.transform = 'translateY(-3px)'; }, { passive: true });
      card.addEventListener('touchend', function () { card.style.transform = ''; }, { passive: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
